module.exports = __webpack_public_path__ + "static/img/m2.aae9518.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/cooperation/m2.png
// module id = TUjU
// module chunks = 3